import React, {FC} from 'react';
import {Property} from "../../../Models/Property";
import {Card, CardContent as MuiCardContent, CardMedia, Theme, Typography, useMediaQuery} from "@mui/material";
import {getTextByCurrentLanguage} from "../../../utils/utils";
import styled from "styled-components";

const CardContent = styled(MuiCardContent)`
  padding-bottom: 16px !important;
  
  p {
    font-size: 14px !important; 
    font-weight: 500;
  }
`

type TypeProps = {
    onClick: (index: number | undefined) => void
    index?: number
}

const Item: FC<Property & TypeProps> = ({ name, general_image, onClick, index }) => {
    const sm = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));

    return (
        <Card variant="outlined" onClick={() => onClick(index)}>
            <CardMedia
                sx={{ height: sm ? 170 : 150 }}
                image={general_image}
                title={getTextByCurrentLanguage(name)}
            />
            <CardContent>
                <Typography>{getTextByCurrentLanguage(name)}</Typography>
            </CardContent>
        </Card>
    );
};

export default Item;